import type { ProfileName } from './profile-names';

/** API / backend profile (dns, ws, video, ICE…). Switch via angular fileReplacements. */
export const ACTIVE_PROFILE: ProfileName = 'finek';
